import BrowseInfluencerDetail from "@/Component/Brand/BrowseInfluencer/BrowseInfluencerDetail";

const BrowseInfluencerDetailPage = async ({ params }: { params: Promise<{ slug: string | string[] }>; }) => {
    const resolvedParams = await params;
    const category_slug = Array.isArray(resolvedParams.slug) ? resolvedParams.slug[0] : resolvedParams.slug;

    return <BrowseInfluencerDetail category_slug={category_slug} />;
};

export default BrowseInfluencerDetailPage;
